import React, { useState, useEffect, Fragment } from "react";
import ProfileBar from "./components/ProfileBar";
import PageTitle from "./components/PageTitle";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import {
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Grid,
  Icon,
  InputAdornment,
  LinearProgress,
  TextField,
} from "@mui/material";
import moment from "moment";
import dayjs from "dayjs";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { fetchData, currentFormat } from "./js/main";
import PageBar from "./components/PageBar";

const limit = 50;
const styles = {
  td: { fontSize: ".7rem", lineHeight: "15px", padding: "7px 3px" },
  bill_btn: { fontSize: ".7rem", lineHeight: "15px", padding: "3px 3px" },
};

export default function RptInvoice(props) {
  const [pageNo, setPageNo] = useState(1);
  const [pageCount, setPageCount] = useState(1);
  const [filter, setFilter] = useState();
  const [invoices, setInvoices] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      let toDate = new Date();
      let fromDate = new Date();
      // let fromDate = "2025-04-21";
      setFilter({
        profile: props.profile,
        skip: 0,
        fromDate,
        toDate,
        keyword: "",
        operators: [props.profile.usn],
        showAll: true,
      });
    })();
  }, [props]);

  useEffect(() => {
    (async () => {
      if (filter) {
        setLoading(true);
        var toDate = new Date(filter.toDate);
        toDate.setDate(toDate.getDate() + 1);
        let match = {};
        let options = {
          sort: { invoice_no: 1 },
          limit,
          skip: filter.skip,
          facet: true,
        };
        if (filter.keyword.trim() !== "") {
          match = {
            value: filter.keyword.trim(),
            fields: [
              "invoice_id",
              "debtor_name",
              // "details.account_name",
              // "canceled.new_bill_no",
              "operator.usn",
            ],
          };
          options.keyword = match;
        } else {
          match = {
            $and: [
              {
                $or: [
                  {
                    // for v3
                    update_time: {
                      $gte: moment(filter.fromDate).format("YYYY-MM-DD"),
                    },
                  },
                  {
                    // for older ver 3
                    create_date: {
                      $gte: moment(filter.fromDate).format("YYYY-MM-DD"),
                    },
                  },
                ],
              },
              {
                $or: [
                  {
                    // for v3
                    update_time: {
                      $lt: moment(toDate).format("YYYY-MM-DD"),
                    },
                  },
                  {
                    // for older ver 3
                    create_date: {
                      $lt: moment(toDate).format("YYYY-MM-DD"),
                    },
                  },
                ],
              },
            ],
          };
          if (filter.showAll !== true) {
            match["$and"].push({ "operator.usn": filter.profile.usn });
          }
          options.match = match;
        }
        let invoices = await fetchData("post", "/v3/invoice/report", options);
        setInvoices(invoices);
        setLoading(false);
      }
    })();
  }, [filter]);

  useEffect(() => {
    if (invoices) {
      let count = Math.ceil(invoices.count / limit);
      if (count < 1) count = 1;
      setPageCount(count);
    }
  }, [invoices]);

  function changeFilter(field, value) {
    setFilter({ ...filter, [field]: value, skip: 0 });
    setPageNo(1);
  }
  function changePage(no) {
    let skip = (no - 1) * limit;
    setFilter({ ...filter, skip });
    setPageNo(no);
  }
  return (
    <div className="content">
      <ProfileBar profile={props.profile} />
      <PageTitle page={props.page} />

      {filter && invoices && (
        <FilterForm
          filter={filter}
          onChangeFilter={changeFilter}
          count={invoices.count || 0}
        />
      )}
      {loading ? (
        <div style={{ paddingTop: "50px" }}>
          <LinearProgress />
        </div>
      ) : (
        <>
          {invoices && (
            <div style={{ paddingTop: "10px" }}>
              <PageBar
                onChangePage={changePage}
                count={pageCount}
                pageNo={pageNo}
              />
              <InvoiceTable invoices={invoices} />
              <FacetArea facet={invoices.facet} invoiceCount={invoices.count} />
            </div>
          )}
        </>
      )}
    </div>
  );
}

function FacetArea(props) {
  const [facet, setFacet] = useState();
  useEffect(() => {
    if (props) {
      setFacet(props.facet);
    }
  }, [props]);

  return (
    <div>
      {facet && (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <TableContainer component={Paper} sx={{ marginTop: "15px" }}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell colSpan={8}>Billers</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={{ maxWidth: "60px" }}>No</TableCell>
                    <TableCell sx={{ maxWidth: "100px" }}>Chart Code</TableCell>
                    <TableCell sx={{ maxWidth: "100px" }}>
                      Account Code
                    </TableCell>
                    <TableCell>Biller Name</TableCell>
                    <TableCell sx={{ maxWidth: "100px" }}>Bill Count</TableCell>
                    <TableCell sx={{ maxWidth: "80px" }}>Income</TableCell>
                    <TableCell sx={{ maxWidth: "80px" }}>Cancel</TableCell>
                    <TableCell sx={{ maxWidth: "80px" }}>Amount</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {facet.billers.length === 0 && (
                    <TableRow>
                      <TableCell
                        colSpan={8}
                        align="center"
                        sx={{ lineHeight: "70px", color: "#999" }}
                      >
                        No information found
                      </TableCell>
                    </TableRow>
                  )}
                  {facet.billers.map((biller, key) => (
                    <TableRow key={key} hover>
                      <TableCell align="center">{key + 1}</TableCell>
                      <TableCell align="center">{biller.chart_code}</TableCell>
                      <TableCell align="center">
                        {biller.account_code}
                      </TableCell>
                      <TableCell>{biller.biller_name}</TableCell>
                      <TableCell align="center">
                        {currentFormat(biller.count, true)}
                      </TableCell>
                      <TableCell align="right">
                        {currentFormat(biller.income)}
                      </TableCell>
                      <TableCell align="right">
                        {currentFormat(biller.canceled_amount)}
                      </TableCell>
                      <TableCell align="right">
                        {currentFormat(biller.amount)}
                      </TableCell>
                    </TableRow>
                  ))}
                  <TableRow hover>
                    <TableCell colSpan={4} align="center" className="bold">
                      Total
                    </TableCell>
                    <TableCell align="center" className="bold">
                      {currentFormat(facet.bill_count, true)}
                    </TableCell>
                    <TableCell align="right" className="bold">
                      {currentFormat(facet.income)}
                    </TableCell>
                    <TableCell align="right" className="bold">
                      {currentFormat(facet.canceled_amount)}
                    </TableCell>
                    <TableCell align="right" className="bold">
                      {currentFormat(facet.amount)}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
          <Grid item xs={12} lg={6}>
            <TableContainer component={Paper} sx={{ marginTop: "15px" }}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell colSpan={6}>Operators</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={{ maxWidth: "60px" }}>No</TableCell>
                    <TableCell>Account</TableCell>
                    <TableCell sx={{ maxWidth: "100px" }}>Bill Count</TableCell>
                    <TableCell sx={{ maxWidth: "80px" }}>Income</TableCell>
                    <TableCell sx={{ maxWidth: "80px" }}>Cancel</TableCell>
                    <TableCell sx={{ maxWidth: "80px" }}>Amount</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {facet.operators.length === 0 && (
                    <TableRow>
                      <TableCell
                        colSpan={6}
                        align="center"
                        sx={{ lineHeight: "70px", color: "#999" }}
                      >
                        No information found
                      </TableCell>
                    </TableRow>
                  )}
                  {facet.operators.map((operator, key) => (
                    <TableRow key={key} hover>
                      <TableCell align="center">{key + 1}</TableCell>
                      <TableCell>{operator.label}</TableCell>
                      <TableCell align="center">
                        {currentFormat(operator.count, true)}
                      </TableCell>
                      <TableCell align="right">
                        {currentFormat(operator.income)}
                      </TableCell>
                      <TableCell align="right">
                        {currentFormat(operator.canceled_amount)}
                      </TableCell>
                      <TableCell align="right">
                        {currentFormat(operator.amount)}
                      </TableCell>
                    </TableRow>
                  ))}
                  <TableRow hover>
                    <TableCell colSpan={2} align="center" className="bold">
                      Total
                    </TableCell>
                    <TableCell align="center" className="bold">
                      {currentFormat(facet.bill_count, true)}
                    </TableCell>
                    <TableCell align="right" className="bold">
                      {currentFormat(facet.income)}
                    </TableCell>
                    <TableCell align="right" className="bold">
                      {currentFormat(facet.canceled_amount)}
                    </TableCell>
                    <TableCell align="right" className="bold">
                      {currentFormat(facet.amount)}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
          <Grid item xs={12} lg={6}>
            <TableContainer component={Paper} sx={{ marginTop: "15px" }}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell colSpan={6}>Pay Types</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={{ maxWidth: "60px" }}>No</TableCell>
                    <TableCell>Type Name</TableCell>
                    <TableCell sx={{ maxWidth: "100px" }}>Bill Count</TableCell>
                    <TableCell sx={{ maxWidth: "80px" }}>Income</TableCell>
                    <TableCell sx={{ maxWidth: "80px" }}>Cancel</TableCell>
                    <TableCell sx={{ maxWidth: "80px" }}>Amount</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {facet.pay_type &&
                    facet.pay_type.map((type, key) => (
                      <TableRow key={key} hover>
                        <TableCell align="center">{key + 1}</TableCell>
                        <TableCell>{type.label}</TableCell>
                        <TableCell align="center">
                          {currentFormat(type.count, true)}
                        </TableCell>
                        <TableCell align="right">
                          {currentFormat(type.income)}
                        </TableCell>
                        <TableCell align="right">
                          {currentFormat(type.canceled_amount)}
                        </TableCell>
                        <TableCell align="right">
                          {currentFormat(type.amount)}
                        </TableCell>
                      </TableRow>
                    ))}
                  <TableRow hover>
                    <TableCell colSpan={2} align="center" className="bold">
                      Total
                    </TableCell>
                    <TableCell align="center" className="bold">
                      {currentFormat(facet.pay_type_count, true)}
                    </TableCell>
                    <TableCell align="right" className="bold">
                      {currentFormat(facet.income)}
                    </TableCell>
                    <TableCell align="right" className="bold">
                      {currentFormat(facet.canceled_amount)}
                    </TableCell>
                    <TableCell align="right" className="bold">
                      {currentFormat(facet.amount)}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      )}
    </div>
  );
}

function InvoiceTable({ invoices }) {
  const fields = [
    { title: "Invoice No" },
    { title: "Full name" },
    { title: "Debt Amount" },
    { title: "Biller name" },
    { title: "Bill no" },
    { title: "Pay type" },
    { title: "Date/Time" },
    { title: "Pay Amount" },
    { title: "Operator" },
    { title: "Cancel" },
    { title: "New Bill" },
  ];
  // const bill_fields = [
  //   { name: "bill_id" },
  //   { name: "transactionType" },
  //   { name: "transactionDateandTime", type: "date" },
  //   { name: "amount", type: "currency" },
  //   { name: "operator", subfield: "usn" },
  //   { name: "canceled", subfield: "status", type: "check" },
  // ];
  return (
    <div>
      <TableContainer component={Paper} sx={{ marginTop: "15px" }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              {fields.map((field, key) => (
                <TableCell key={key} sx={styles.td}>
                  {field.title}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {invoices.result.map((invoice, key) => (
              <Fragment key={key}>
                <TableRow key={key}>
                  <TableCell
                    sx={styles.td}
                    align="center"
                    rowSpan={invoice.bills.length || 1}
                  >
                    {invoice.invoice_id}
                  </TableCell>
                  <TableCell sx={styles.td} rowSpan={invoice.bills.length || 1}>
                    {invoice.debtor_name}
                  </TableCell>
                  <TableCell
                    sx={styles.td}
                    align="center"
                    rowSpan={invoice.bills.length || 1}
                  >
                    {parseFloat(invoice.amount).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </TableCell>
                  <TableCell sx={styles.td} rowSpan={invoice.bills.length || 1}>
                    {invoice.details.map((detail, key) => (
                      <div
                        key={detail._id}
                        style={{ paddingTop: key > 0 ? "5px" : "0px" }}
                      >
                        {detail.biller_name}
                      </div>
                    ))}
                  </TableCell>
                  {/* {invoice.bills.map((bill, key) => (
                    <BillCell bill={bill} key={key} />
                  ))} */}
                  {invoice.bills && invoice.bills[0] && (
                    <BillCell bill={invoice.bills[0]} key={key} />
                  )}
                </TableRow>

                {invoice.bills.map((bill, key) => (
                  <Fragment key={key}>
                    {key > 0 && (
                      <TableRow>
                        <BillCell bill={bill} />
                      </TableRow>
                    )}
                  </Fragment>
                ))}
              </Fragment>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}

function BillCell({ bill }) {
  // { name: "transactionType" },
  // { name: "transactionDateandTime", type: "date" },
  // { name: "amount", type: "currency" },
  // { name: "operator", subfield: "usn" },
  // { name: "canceled", subfield: "status", type: "check" },
  return (
    <>
      <TableCell sx={styles.td} align="center">
        <Button
          onClick={() =>
            window.open(process.env.PUBLIC_URL + "/bill/" + bill.bill_id)
          }
          sx={styles.bill_btn}
        >
          {bill.bill_id}
        </Button>
      </TableCell>
      <TableCell sx={styles.td} align="center">
        {bill.transactionType}
      </TableCell>
      <TableCell sx={styles.td} align="center">
        {moment(bill.transactionDateandTime).format("DD MMM YYYY, HH:mm:ss")}
      </TableCell>
      <TableCell sx={styles.td} align="center">
        {parseFloat(bill.amount).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}
      </TableCell>
      <TableCell sx={styles.td} align="center">
        {bill.operator && (
          <>
            {bill.operator.name &&
            bill.operator.name.indexOf("undefined") < 0 ? (
              <>{bill.operator.name}</>
            ) : (
              <>{bill.operator.usn}</>
            )}
          </>
        )}
      </TableCell>
      <TableCell sx={styles.td} align="center">
        {bill.canceled.status === true && <Icon>check</Icon>}
      </TableCell>
      <TableCell sx={styles.td} align="center">
        <Button
          onClick={() =>
            window.open(
              process.env.PUBLIC_URL + "/bill/" + bill.canceled.new_bill_no
            )
          }
          sx={styles.bill_btn}
        >
          {bill.canceled.new_bill_no}
        </Button>
      </TableCell>
    </>
  );
}

function FilterForm({ filter, onChangeFilter, count }) {
  return (
    <Grid container sx={{ paddingTop: "10px" }} spacing={2}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Grid item xs={6} lg={3}>
          <DatePicker
            format="DD MMM YYYY"
            label="Form Date"
            value={dayjs(filter.fromDate)}
            onChange={(newValue) =>
              onChangeFilter("fromDate", new Date(newValue))
            }
            slotProps={{
              textField: {
                InputLabelProps: { shrink: true },
                fullWidth: true,
                size: "small",
              },
            }}
          />
        </Grid>
        <Grid item xs={6} lg={3}>
          <DatePicker
            format="DD MMM YYYY"
            onChange={(newValue) =>
              onChangeFilter("toDate", new Date(newValue))
            }
            label="To Date"
            value={dayjs(filter.toDate)}
            slotProps={{
              textField: {
                InputLabelProps: { shrink: true },
                fullWidth: true,
                size: "small",
              },
            }}
          />
        </Grid>
        <Grid item xs={12} lg={6}>
          <TextField
            fullWidth
            InputLabelProps={{ shrink: true }}
            label="Keyword"
            placeholder="ค้นหา..."
            size="small"
            id="keyword"
            // value={filter.keyword}
            onKeyUp={(e) =>
              e.key === "Enter" && onChangeFilter("keyword", e.target.value)
            }
            InputProps={{
              sx: { paddingRight: "0px" },
              endAdornment: (
                <InputAdornment position="start">
                  <Icon>search</Icon>
                </InputAdornment>
              ),
            }}
          />
          <div
            style={{
              textAlign: "right",
              width: "130px",
              margin: "auto 0px auto auto",
            }}
          >
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    // defaultChecked={false}
                    checked={filter.showAll}
                    onChange={(e) =>
                      onChangeFilter("showAll", e.target.checked)
                    }
                  />
                }
                label={<div>แสดงทั้งหมด</div>}
              />
            </FormGroup>
          </div>
        </Grid>
        <Grid xs={12} item className="bold">
          Result : {count} invoice(s)
        </Grid>
      </LocalizationProvider>
    </Grid>
  );
}
